import { render, staticRenderFns } from "./CombookBinding.vue?vue&type=template&id=cabb8e34&"
import script from "./CombookBinding.vue?vue&type=script&lang=ts&"
export * from "./CombookBinding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports